// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-padding[data-v-f4ca55d2]{padding-top:15rem;padding-bottom:15rem}.error-padding[data-v-f4ca55d2]{padding-top:5rem;padding-bottom:5rem}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
